<template>
  <!-- sidenav -->
  <aside
    id="sidenav-main"
    :class="{
      'fixed  w-full lg:mr-3 sm:static inset-y-0 h-[calc(100vh-1.5rem)] right-0 flex-wrap items-center justify-between block  p-0 my-4 transition-width duration-300 ease-in-out border-0 shadow-none z-[98]  rounded-2xl  overflow-y-auto bg-primary': true,
      'dark:bg-gray-800': context !== 'bayen_school',
      'dark:bg-[#8b1f4a]': context === 'bayen_school',
      hideSideBar: !globalStore.isToggled,
      'basis-full sm:basis-auto ': globalStore.isToggled
    }"
  >
    <!-- header -->
    <div class=" " v-auto-animate>
      <!-- x i -->
      <!-- <i class="absolute top-0 left-0 p-4 opacity-50 cursor-pointer fas fa-times text-white xl:hidden"
        aria-hidden="true" sidenav-close-btn=""></i> -->

      <template v-if="globalStore.isToggled">
        <div class="h-20 flex justify-between items-center px-6">
          <a class="block m-0 text-sm whitespace-nowrap text-white" href="#" target="_blank">
            <span
              class="mr-1 font-semibold transition-all duration-200 ease-in-out opacity-100 text-base"
              >بوابة المعلمين</span
            >
        <div v-if="isSmallScreen" class="text-xxs font-bold text-gray-700 dark:text-gray-300 capitalize mr-1">v 1.5.0</div>

          </a>
          <span
            class="icon-[material-symbols--close] size-6 text-white sm:hidden cursor-pointer"
            @click="globalStore.toggleSidebar()"
          ></span>
        </div>
      </template>

      <template v-else>
        <div class="px-1 py-2 w-full flex justify-center items-center">
          <img src="@/assets/logo.jpg" alt="logo" class="bg-white rounded w-12 p-1" />
        </div>
      </template>
    </div>

    <!-- //---------hr----------// -->

    <div
      class="h-px mt-0 bg-transparent bg-gradient-to-r from-transparent via-gray-400 to-transparent"
      :class="{
        'dark:via-gray-600': context !== 'bayen_school',
        'dark:via-pink-700': context === 'bayen_school'
      }"
    ></div>

    <div class="items-center block w-full h-auto grow basis-full" id="sidenav-collapse-main" v-auto-animate>
      <!-- primary list  -->

      <ul class="flex flex-col pr-0 mb-0 list-none mt-4">
        <!-- primary list item -->

        <li class="mt-8 w-full" @click="isSmallScreen ? globalStore.toggleSidebar() : ''">
          <router-link
            to="/"
            class="ease-in-out justify-center text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white "
          >
            <!-- primary anchor  -->

            <!-- big anchor expandable -->

            <div
              class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
            >
              <span class="icon-[tabler--home] size-5"></span>
            </div>

            <!-- primary span -->

            <span
              class="duration-300 pointer-events-none ease opacity-100"
              v-if="globalStore.isToggled"
            >
              الرئيسية</span
            >
          </router-link>
        </li>

        <li class="mt-4 w-full" @click="isSmallScreen ? globalStore.toggleSidebar() : ''">
          <!-- primary anchor  -->

          <router-link
            to="/evaluation"
            class="ease-in-out justify-center text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white"
          >
            <!-- big anchor expandable -->

            <div
              class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
            >
              <span class="icon-[material-symbols--check] size-5"></span>
            </div>

            <!-- primary span -->

            <span
              class="duration-300 pointer-events-none ease opacity-100"
              v-if="globalStore.isToggled"
              >التقييم</span
            >
          </router-link>
        </li>

        <li class="mt-4 w-full" @click="isSmallScreen ? globalStore.toggleSidebar() : ''">
          <!-- primary anchor  -->

          <router-link
            to="/groups"
            class="ease-in-out justify-center text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white"
          >
            <div
              class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z"
                />
              </svg>
            </div>

            <span
              class="mr-1 duration-300 pointer-events-none ease opacity-100"
              v-if="globalStore.isToggled"
              >الحلقات</span
            >
          </router-link>
        </li>

        <li class="mt-4 w-full" @click="isSmallScreen ? globalStore.toggleSidebar() : ''">
          <!-- primary anchor  -->

          <router-link
            to="/students"
            class="ease-in-out justify-center text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white"
          >
            <div
              class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
            >
              <span class="icon-[ph--users-three] size-5"></span>
            </div>

            <span
              class="mr-1 duration-300 pointer-events-none ease opacity-100"
              v-if="globalStore.isToggled"
              >الطلاب</span
            >
          </router-link>
        </li>

        <li
          v-if="ability.can('manage', 'Presence')"
          class="mt-4 w-full"
          @click="isSmallScreen ? globalStore.toggleSidebar() : ''"
        >
          <router-link
            to="/presence"
            class="ease-in-out justify-center text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white"
          >
            <div
              class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
            >
              <span class="icon-[tabler--checkup-list] size-5"></span>
            </div>
            <span
              class="mr-1 duration-300 pointer-events-none ease opacity-100"
              v-if="globalStore.isToggled"
              >الحضور</span
            >
          </router-link>
        </li>

        <li
          class="mt-4 w-full"
          @click="isSmallScreen ? globalStore.toggleSidebar() : ''"
          v-if="ability.can('manage', 'Absences')"
        >
          <router-link
            to="/absence"
            class="ease-in-out justify-center text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white"
          >
            <div
              class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
            >
              <span class="icon-[ph--empty] size-5"></span>
            </div>
            <span
              class="mr-1 duration-300 pointer-events-none ease opacity-100"
              v-if="globalStore.isToggled"
              >الغياب</span
            >
          </router-link>
        </li>

        <!-- <li
          class="mt-4 w-full"
          @click="isSmallScreen ? globalStore.toggleSidebar() : ''"
          v-if="ability.can('manage', 'Visits')"
        >
          <router-link
            to="/visits"
            class="ease-in-out justify-center text-sm leading-default py-2.7 active after:ease-in-out after:font-awesome-5-free my-0 mx-2 flex items-center whitespace-nowrap px-4 font-medium shadow-none transition-colors after:mr-auto after:inline-block after:font-bold after:text-slate-800/50 after:antialiased after:transition-all after:duration-200 text-white dark:opacity-80 dark:after:text-white/50 dark:after:text-white"
          >
            <div
              class="stroke-none flex items-center justify-center rounded-lg bg-center fill-current px-2.5 text-center"
            >
              <span class="icon-[material-symbols--nest-doorbell-visitor-outline] size-5"></span>
            </div>
            <span
              class="mr-1 duration-300 pointer-events-none ease opacity-100"
              v-if="globalStore.isToggled"
              >الزيارات</span
            >
          </router-link>
        </li> -->

        <MenuGroup />
      </ul>
    </div>

    <!--  -->
  </aside>
</template>

<script setup lang="ts">
import MenuGroup from '@/components/MenuGroup.vue'
import { auth } from '@/stores/auth'
import { useGlobalStore } from '@/stores/global'
import { useMediaQuery } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import { context } from '@/services'

const globalStore = useGlobalStore()

const { ability } = auth()
const isSmallScreen = useMediaQuery('(max-width: 640px)')
function updateScreenSize() {
  globalStore.isSmallScreen = window.innerWidth < 1200
}
const { user } = storeToRefs(auth())

const router = useRouter()

router.afterEach((to, from) => {
  if (isSmallScreen.value) {
    globalStore.isToggled = false
  }
})

onMounted(() => {
  const isToggled = localStorage.getItem('isToggled')
  if (isToggled) {
    if (isSmallScreen.value) {
      globalStore.isToggled = false
    } else {
      globalStore.isToggled = isToggled == 'true'
    }
  }
  updateScreenSize()
  window.addEventListener('resize', updateScreenSize)
})

onBeforeRouteLeave(() => {
  window.removeEventListener('resize', updateScreenSize)
})
</script>

<style>
body:not([data-context='bayen_school']) .router-link-active {
  @apply bg-white text-primary rounded-lg fill-primary;
}

body[data-context='bayen_school'] .router-link-active {
  @apply bg-white text-[#d6336c] rounded-lg fill-[#d6336c];
}

body:not([data-context='bayen_school']) .dark .router-link-active {
  @apply dark:bg-gray-700 dark:text-white dark:fill-white;
}

body[data-context='bayen_school'] .dark .router-link-active {
  @apply dark:bg-[#5a1430] dark:text-pink-200 dark:fill-pink-200;
}

#sidenav-main {
  transition: all 0.3s ease-in-out;
}
@media (min-width: 576px) {
  .hideSideBar {
    width: 5rem !important;
    min-width: 5rem !important;
  }

  #sidenav-main {
    width: 15rem;
    min-width: 15rem;
  }
}

@media (max-width: 576px) {
  .hideSideBar {
    width: 0rem !important;
  }
}
</style>
